import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareIncidentsClassicRoute: InvariantJiraRoute = {
	name: 'software-incidents-classic',
	path: '/jira/software/c/projects/:projectKey/incidents',
};
